import { render, staticRenderFns } from "./PostsInRow.vue?vue&type=template&id=462ff6f4&"
import script from "./PostsInRow.vue?vue&type=script&lang=js&"
export * from "./PostsInRow.vue?vue&type=script&lang=js&"
import style0 from "./PostsInRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports